import Component from '@bythepixel/component-loader';
import { breakpoints } from '@Front/constants';
import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 2.3,
  peak: 0.3,
  rewind: false,
  bound: true,
  gap: 21,
  breakpoints: {
    [breakpoints['break-1']]: {
      focusAt: 'center',
      perView: 1,
    },
    [breakpoints['break-3']]: {
      perView: 1.3,
      peak: 0.3,
    },
  },
};

const selectors = {
  slideSelector: '[data-general-slider="slide"]',
  leftArrowSelector: '[data-general-slider-arrow-left]',
  rightArrowSelector: '[data-general-slider-arrow-right]',
  arrowsContainerSelector: '[data-general-slider="arrows"]',
  slideIndicatorSelector: '[data-general-slider-indicator]',
  slideIndicatorActiveClass: 'nav-btn--active',
};

export default class SectionGeneralSlider extends Component {
  static selector = '[data-comp-general-slider]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.subNavSlider = new GlideSlider(containerEl, glideOptions, selectors);
    this.subNavSliderGlideInstance = this.subNavSlider.getGlideSlider();

    this.subNavSliderGlideInstance.on(['mount.after', 'run.after'], () => {
      this.subNavSlider.handleArrowButtonVisibility();
    });

    this.subNavSliderGlideInstance.mount();
  }
}
